import React from 'react';
import classnames from 'classnames';

class Select extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        const defaultSelection = this.props.defaultSelection >= 0 ? this.props.defaultSelection : 0;
        this.state = { selected: this.props.options[defaultSelection] || { label: 'initial value', value: -1 } };
    }

    componentWillReceiveProps({ enabled, options = [] }) {
        if (!enabled) {
            const option = options[0];
            this.setState({ selected: option });
            this.props.onChange(option);
        }
    }

    handleClick(option, event) {
        event.preventDefault();
        this.setState({ selected: option });
        this.props.onChange(option);
    }

    handleChange(event) {
        const value = event.target.value.toString();
        const index = this.props.options.map((opt) => opt.value.toString()).indexOf(value);
        const option = this.props.options[index];
        this.setState({ selected: option });
        this.props.onChange(option);
    }

    render() {
        const { options = [], menuSizeClass, name } = this.props;
        const menuClassName = classnames('dropdown-menu', menuSizeClass);

        return (
            <span className="dropdown-wrapper-container">
                <div className="dropdown-wrapper display-desktop hoverable" data-behavior="button_dropdown">
                    <button type="button" className="button-filter med dropdown-toggle">{this.state.selected.label}</button>
                    <ul className={menuClassName} role="menu">
                        {options.map((option) => (
                            <li key={`select-${option.label}`}>
                                <a onClick={(event) => { this.handleClick(option, event); }}>{option.label}</a>
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="dropdown-wrapper display-mobile mobile-dropdown">
                    <span className="mobile-arrow" />
                    <select onChange={this.handleChange} value={this.state.selected.value} name={name}>
                        {options.map((opt) => (<option value={opt.value} key={`selectmobile-${opt.label}`}>{opt.label}</option>))}
                    </select>
                </div>
            </span>
        );
    }
}

Select.propTypes = {
    name: React.PropTypes.string,
    options: React.PropTypes.array,
    onChange: React.PropTypes.func,
    menuSizeClass: React.PropTypes.string,
    defaultSelection: React.PropTypes.number,
    enabled: React.PropTypes.bool
};

Select.defaultProps = {
    onChange: () => {},
    menuSizeClass: 'med',
    defaultSelection: 0,
    enabled: true
};

export default Select;



// WEBPACK FOOTER //
// ./app/common/Select.js